import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Button, FormGroup, Alert, Tabs, Tab } from "react-bootstrap";
import { ModalBody, Modal, } from "reactstrap";
import "./add-details.css";
import { addDemand, getAllDemand, getAllInventory, searchDemandReport, getApproveDemand, getWarehouseData } from "./AddDetails.actions";
import { connect } from "react-redux";
import { isEmpty, find, isUndefined } from "lodash";
import moment from 'moment';
import Spinner from 'react-bootstrap/Spinner';
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { IconButton } from "@material-ui/core";
import DemandReport from "./DemandReport";
import Select from 'react-select';
import Swal from 'sweetalert';

const DemandPDF = (props) => {
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [demandNameValue, setDemandNameValue] = useState();
    const [demandNameLabel, setDemandNameLabel] = useState();
    const [visibleAlert, setAlertVisible] = useState(false);

    const handleVisible = () => {
        setAlertVisible(true)
        setTimeout(() => {
            setAlertVisible(false)
        }, 9000);
        Swal({
            title: "Data Not Found",
            text: "Data Not Found",
            icon: "info",
            button: "Ok",
        });
    }

    const getDemandList = props.approveDemandList.map((x) => { let data = { value: x.demandId, label: x.demandId + " / " + x.demandName }; return data })

    const handleChangeGetDemand = (selectedOption) => {
        setDemandNameValue(selectedOption.value);
        setDemandNameLabel(selectedOption.label);
    };

    const exportPDF = () => {
        props.searchDemandReport({
            demandId: demandNameValue,
            startedDate: "",
            endDate: ""
        }, demandNameLabel, startDate, endDate, handleVisible);
        setStartDate("");
        setEndDate("");
        setDemandNameLabel("");
    }

    useEffect(() => {
        props.getAllInventory({
            startedDate: "",
            endDate: "",
            wareHouseId: "",
            subCategoryId: "",
            categoryId: "",
        })
        // props.getAllDemand();
        props.getApproveDemand();
        props.getWarehouseData();
    }, []);
    return (
        <>
            {props.isFetchningApproveDemandList || props.isFetchingSearchDemandList ? (
                <div className="loader-div">
                    <Button variant="info" disabled>
                        <Spinner
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            variant="info"
                        />
                        {props.isFetchingSearchDemandList ? 'Downloading PDF...' : 'Loading...'}

                    </Button>
                </div>
            ) : (
                <Container fluid>
                    <div className="main">
                        <Row>
                            <Col xl="4" lg="4" md="6" sm="6">
                                <FormGroup>
                                    <Form.Label>
                                        <b>Start Date :</b>
                                    </Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    >
                                    </Form.Control>
                                </FormGroup>
                            </Col>
                            <Col xl="4" lg="4" md="6" sm="6">
                                <FormGroup>
                                    <Form.Label>
                                        <b>End Date</b>
                                    </Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    >
                                    </Form.Control>
                                </FormGroup>
                            </Col>
                            <Col xl="4" lg="4" md="12" sm="12">
                                <Form.Group>
                                    <Form.Label>
                                        <b>Demand#</b>
                                    </Form.Label>
                                    <Select
                                        value={{ label: demandNameLabel }}
                                        placeholder="Select Demand..."
                                        onChange={handleChangeGetDemand}
                                        options={isEmpty(getDemandList) ? [] : getDemandList.reverse()}

                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <div className="sendDiv">
                            {isUndefined(demandNameLabel) ? <Button disabled style={{ marginLeft: "2%", color: "white", width: "20%", backgroundColor: "black", border: "1px solid black" }}>Generate Demand Report</Button> : props.isFetchingSearchDemandList ? <Button className="sendButton">Downloading PDF</Button> : <Button className="sendButton" onClick={() => exportPDF()}>Generate Demand Report</Button>}
                        </div>
                    </div>
                </Container>
            )}
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        getAllDemand: () => dispatch(getAllDemand()),
        getAllInventory: (data) => dispatch(getAllInventory(data)),
        searchDemandReport: (data, name, startDate, endDate, handleVisible) => dispatch(searchDemandReport(data, name, startDate, endDate, handleVisible)),
        getApproveDemand: () => dispatch(getApproveDemand()),
        getWarehouseData: () => dispatch(getWarehouseData())
    };
};
const mapStateToProps = (state, ownProps) => ({
    warehouseList: state.AddDataReducer.warehouseList,
    isFetchingwareHouseList: state.AddDataReducer.isFetchingwareHouseList,
    allInventory: state.AddDataReducer.allInventory,
    isFetchingDemand: state.AddDataReducer.isFetchingDemand,
    isFetchingInventoryAll: state.AddDataReducer.isFetchingInventoryAll,
    isAddingDemanddata: state.AddDataReducer.isAddingDemanddata,
    notAddDemandData: state.AddDataReducer.notAddDemandData,
    approveDemandList: state.AddDataReducer.approveDemandList,
    isFetchningApproveDemandList: state.AddDataReducer.isFetchningApproveDemandList,
    isFetchingSearchDemandList: state.AddDataReducer.isFetchingSearchDemandList,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DemandPDF);